import { render, staticRenderFns } from "./myAccount.vue?vue&type=template&id=38a03b12&scoped=true&"
import script from "./myAccount.vue?vue&type=script&lang=js&"
export * from "./myAccount.vue?vue&type=script&lang=js&"
import style0 from "./myAccount.vue?vue&type=style&index=0&id=38a03b12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a03b12",
  null
  
)

export default component.exports